import axios from 'axios';

const documentApi = axios.create({
    baseURL: process.env.REACT_APP_DOCUMENT_API_URL
});

export default documentApi;